import Vue from 'vue'

const el = document.querySelector('#cc-signup')
if (el != null) {
  var vm = new Vue({
    delimiters: ['[[', ']]'],
    methods: {
      async signup () {
        const formData = new FormData(this.$el) // reference to form element
        for (const [key, val] of formData.entries()) {
          if (key === 'email') {
            const url = 'http://oi.vresp.com/?fid=bd7c51464b&email_address=' + val
            window.open(url, '_blank');
          }
        }
      }
    }
  })
  vm.$mount(el)
}
